import React from 'react';
import styled from 'styled-components';
import { AutoSuggest } from 'components/Form/AutoSuggest';
import { Checkbox } from 'components/Form/Checkbox';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  padding-left: 30px;
  max-width: 500px;
`;

const Options = [
  { label: 'Lenient', value: 'lenient' },
  { label: 'Strict', value: 'strict' },
];

export const ReservedSeatSettings = ({
  setFieldValue,
  values,
  handleBlur,
}) => {
  return (
    <Container>
      <AutoSuggest
        name="ownership"
        placeholder=""
        label="Orphaned Seat Mode"
        onChange={(value) => {
          setFieldValue('orphaned_seats', value);
        }}
        value={values.orphaned_seats}
        closeMenuOnSelect
        options={Options}
      />

      <Checkbox
        name="best_available"
        checked={values.best_available}
        onChange={(event) => {
          const value = event.target?.checked;
          setFieldValue('best_available', value);
        }}
        rightText={'Turn On Best Available'}
        onBlur={handleBlur}
      />
    </Container>
  );
};
